import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';

const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

export const OcurrencesMonth = () => {
    const { chartData } = useOcurrencesChartsDataContext();

    const getMonthLabel = (mes) => {
        const monthIndex = parseInt(mes) - 1;
        return monthNames[monthIndex] || mes;
    };

    const rawData = chartData?.ocurrencesMonth || [];

    const series = [
        {
            name: 'Total',
            data: chartData?.ocurrencesMonth?.map(item => item.total)
        },
        {
            name: 'Madrugada',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_madrugada)
        },
        {
            name: 'Manhã',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_manha)
        },
        {
            name: 'Tarde',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_tarde)
        },
        {
            name: 'Noite',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_noite)
        },
        {
            name: 'Não Identificado',
            data: chartData?.ocurrencesMonth?.map(item => item.horario_nao_identificado)
        }
    ];

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title={'Período das Ocorrências (Mensal)'}
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
            stacked
        />
    );
};